
import React from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { CertificatesAnalyticsContent } from '@/components/admin/certificates/CertificatesAnalyticsContent';

export default function CertificatesAnalytics() {
  return (
    <AdminLayout>
      <CertificatesAnalyticsContent />
    </AdminLayout>
  );
}
